<div #tooltipContainer>
    <span *ngIf="showTooltip" [valgTooltip]="value" positionX="start" [enableTooltipOnClick]="false" [offsetX]="-24">{{ value }}</span>
    <span *ngIf="!showTooltip">{{ tryGetTranslatedValue(column) | translate }}</span>
</div>